





























import { HasTaskMixin, Loader } from 'mycorems-app-shared';
import isGranted from '../../auth/isGranted';
import { Service, AccountService } from '../../types';
import repository from './account-service-repository';
import serviceRepository from '../../service/service-repository';
import { enable, disable } from '.';

interface Data {
  services: Service[],
  accountServices: AccountService[],
}

export default HasTaskMixin.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      services: [],
      accountServices: [],
    };
  },
  watch: {
    accountId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
  },
  computed: {
    canToggle(): boolean {
      return (
        isGranted('ENABLE_ACCOUNT_SERVICE', [this.accountId])
        && isGranted('DISABLE_ACCOUNT_SERVICE', [this.accountId])
      );
    },
  },
  methods: {
    toggle(serviceId: string, value: boolean): void {
      if (value) {
        this.enableService(serviceId);
      } else {
        this.disableService(serviceId);
      }
    },
    isEnabled(serviceId: string): boolean {
      const accountService = this.accountServices.find(
        acctService => acctService.service.id === serviceId,
      );
      return (accountService !== undefined);
    },
    add(accountService: AccountService): void {
      this.accountServices.unshift(accountService);
    },
    remove(accountServiceId: string): void {
      const index = this.accountServices.findIndex(
        acctService => acctService.id === accountServiceId,
      );
      if (index >= 0) {
        this.accountServices.splice(index, 1);
      }
    },
    enableService(serviceId: string): void {
      this.task = enable(this.accountId, serviceId);
      this.task.then((accountService: AccountService) => {
        this.add(accountService);
      });
    },
    disableService(serviceId: string): void {
      const accountService = this.accountServices.find(
        acctService => acctService.service.id === serviceId,
      );
      if (!accountService) return;
      this.task = disable(accountService.id);
      this.task.then(() => {
        this.remove(accountService.id);
      });
    },
    load(): void {
      this.loadServices();
      this.loadAccountServices();
    },
    loadAccountServices(): void {
      this.task = repository.findAll(this.accountId);
      this.task.then((accountServices: AccountService[]) => {
        this.accountServices = accountServices;
      });
    },
    loadServices(): void {
      this.task = serviceRepository.findCore();
      this.task.then((services) => {
        this.services = services;
      });
    },
  },
  created(): void {
    this.load();
  },
  components: {
    Loader,
  },
});
